import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  
  DiPython,
  DiGit,
} from "react-icons/di";
import {
  SiPytorch,
  SiFirebase,
  SiNextdotjs,
  SiVuedotjs,
  SiMaterialui,
  SiMysql,
  // django
  SiDjango,
  SiOpengl,
  SiBootstrap,
  SiBlender,

} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <CgCPlusPlus />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col> */}
      {/* <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col> */}
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiVuedotjs />
      </Col> */}
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiMaterialui />
      </Col> */}
      
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDjango />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiBootstrap />
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiOpengl />
      </Col> */}
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiBlender />
      </Col> */}
    </Row>
  );
}

export default Techstack;
